<template>
  <AuthenticatedLayout>
    <PageHeader title="Institutions" />
    <institutions-data-table />
  </AuthenticatedLayout>
</template>

<script lang="ts" setup>
import InstitutionsDataTable from "@/components/DataTables/InstitutionsDataTable.vue";
import PageHeader from "@/components/PageHeader.vue";
import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
</script>
